import React from 'react';
import { PapiOriginalsResponse } from '@wix/da-papi-types';
import TextRenderer from '@wix/da-shared-react/pkg/TextRenderer';
import QuestionDisplay from '@wix/da-ds/pkg/originals/QuestionDisplay';
import QuestionViewer from '@wix/da-editor-tiptap/pkg/components/Viewer/presets/OriginalsQuestion';
import AnswerViewer from '@wix/da-editor-tiptap/pkg/components/Viewer/presets/OriginalsAnswer';
import { DuperbrowseDisabled } from '@wix/da-shared-react/pkg/Duperbrowse/DuperbrowseDisabledContext';

interface Props {
  order: PapiOriginalsResponse;
}
const QuestionnaireAnswers: React.FC<Props> = ({ order }) => {
  return (
    <>
      {order.orderAnswers?.map((orderAnswer, idx) => {
        return (
          <div key={idx}>
            <QuestionDisplay
              orderAnswer={orderAnswer}
              editorRenderer={(body, type) => (
                <DuperbrowseDisabled>
                  <TextRenderer
                    textContent={body}
                    tipTapViewer={
                      type === 'question' ? QuestionViewer : AnswerViewer
                    }
                  />
                </DuperbrowseDisabled>
              )}
            />
          </div>
        );
      })}
    </>
  );
};
QuestionnaireAnswers.displayName = 'QuestionnaireAnswers';

export default QuestionnaireAnswers;
